//import { CRUDBasicListComponent } from '../crud-basic-list/crud-basic-list.component';
import { /*CRUDBasicListComponent_Template,*/ CRUDBasicListComponent } from '../crud-basic-list/crud-basic-list.component'; // HTML Template Plugins
import { /*CRUDBasicListComponent_Template,*/ CRUDBasicListForChildComponent } from '../crud-basic-list-for-child/crud-basic-list-for-child.component'; // HTML Template Plugins
//import { AuftragsdatenListComponent_Template } from './auftragsdaten-list.component.include_template'; // HTML Template Plugins

import { Component, OnInit, Inject, forwardRef, Injector, Input, OnChanges, SimpleChanges} from '@angular/core';

import { ActivatedRoute, Router, ActivatedRouteSnapshot, DetachedRouteHandle, Route, RouteReuseStrategy } from '@angular/router';
import { AppComponent } from '../app.component';

//import { IAuftragsdaten } from '../_interfaces/auftragsdaten';
import { AuftragsdatenService } from '../_services/auftragsdaten.service';
import { DokumenteService } from '../_services/dokumente.service';
import { BehaelterService } from '../_services/behaelter.service';
import { DomSanitizer } from '@angular/platform-browser';
import { LeistungPipe } from '../_pipes/leistung.pipe';
import { BenutzerPipe } from '../_pipes/benutzer.pipe';
import { BehaelterPipe } from '../_pipes/behaelter.pipe';
import { DienstleisterPipe } from '../_pipes/dienstleister.pipe';
import { DatumOhneZeitPipe } from '../_pipes/datum-ohne-zeit.pipe';
import { IAuftragsdaten } from '../_interfaces/auftragsdaten';
import { LazyLoadEvent } from 'primeng/api';

@Component({
  selector: 'app-auftragsdaten-list',
  //templateUrl: '../crud-basic-list/crud-basic-list.component.html',
  templateUrl: './auftragsdaten-list.component.html',
  //template: `${CRUDBasicListComponent_Template || ''}${AuftragsdatenListComponent_Template}`,  // HTML Template Plugins
  styleUrls: ['../crud-basic-list/crud-basic-list.component.css','./auftragsdaten-list.component.scss'],
  host: {
    '(window:keydown)': 'hotkeys($event)',
    '(window:resize)': 'sizeTable()'
  }
})
export class AuftragsdatenListComponent extends CRUDBasicListForChildComponent implements OnInit {
  @Input('mode') mode: string; // map oder list

  pageTitle: string = this.translate.instant("Auftragsdaten", true);
  CRUDItemKurzform: string = "Auftragsdaten";
  CRUDItemButtonTitleNeu: string = /*this.translate.instant("Neue Auftragsdaten", true)*/ null;
  CRUDItemBezeichnungSingularCapitalized: string = "Auftragsdaten";
  CRUDItemBezeichnungPluralCapitalized: string = "Auftragsdaten";
  CRUDItemBezeichnungSingular: string = "auftragsdaten";
  CRUDItemBezeichnungPlural: string = "auftragsdaten";
  CRUDItemHelpTopic: string = /*"Auftragsdaten"*/ null;
  CRUDItemRouteSingular: string = "auftragsdaten";
  CRUDItemRoutePlural: string = "auftragsdaten";

  CRUDHideMehrButton: boolean = true;

  //wird ggf. bei mode = map in init gesetzt!
  //CRUDLazyLoad: boolean = true; // "Pseudo"-Lazyload
  //CRUDLazyLoadVirtualRowHeight: number = 40; // bei lazyLoading / virtualScroll muss die TR eine fixe Grösse haben, sonst Scrolling ungenau! - Hier gewünschte Höhe in px angeben

  //debugMode: boolean = true;

  multimark_selectionMode: string = "single"; // ist umschaltbar -> multiple für mehrere Aufträge gleichzeitg markieren
  multimark_selectionButtonItems = [
    {
      id: 'startmulti', label: this.translate.instant(/*this.CRUDItemKurzform+' bearbeiten'*/this.multimark_selectionMode == 'multiple' ? 'Auswahl beenden' : 'Auswählen', true), icon: 'fa fa-bars', automationId: 2, command: (res) => {
        this.multimark_selectionModeChange();
      }
    },
    {
      id: 'mark', label: this.translate.instant(/*this.CRUDItemKurzform+' bearbeiten'*/'Markieren', true), disabled: this.multimark_selectionMode != 'multiple', icon: 'fa fa-square-check', automationId: 10, command: (res) => {
        this.multimark_markDeMarkFromList(false);
      }
    },
    {
      id: 'demark', label: this.translate.instant(/*this.CRUDItemKurzform+' bearbeiten'*/'Markierung aufheben', true), disabled: this.multimark_selectionMode != 'multiple', icon: 'fa fa-square', automationId: 20, command: (res) => {
        this.multimark_markDeMarkFromList(true);
      }
    },
    {
      id: 'deletemark', label: this.translate.instant(/*this.CRUDItemKurzform+' löschen'*/'Auswahl aufheben', true), disabled: this.multimark_selectionMode != 'multiple', icon: 'fa fa-light fa-square', automationId: 30, command: (res) => {
        this.selectedCrudItem = [];
      }
    }
  ];

  // ACHTUNG: killTable_(not)InUse ist HIER IN USE !!!
  killTable_InUse: boolean = false;

  killForPerformance: boolean = false; // table wirklich killen (ngIf) // Performance V2
  killForPerformance_lastScrollPos: number = 0; // save/restore scrollPos bei kill
  killForPerformance_callbackComponentWhenDone: Component = null;
  killForPerformance_callbackFunctionWhenDone: any = null;
  killForPerformance_callbackWhenDone = false;

  //debugMode: boolean = true;

  // customPipe !!!
  leistungPipe: LeistungPipe = new LeistungPipe(this._app, this.sanitizer);
  benutzerPipe: BenutzerPipe = new BenutzerPipe(this._app);
  dienstleisterPipe: DienstleisterPipe = new DienstleisterPipe(this._app);
  datumOhneZeitPipe: DatumOhneZeitPipe = new DatumOhneZeitPipe();
  behaelterPipe: BehaelterPipe = new BehaelterPipe(this.behaelterService);

  //showList: boolean = true;
  //alreadyAusgeblendet = false;

  zaehlerEnabled: boolean = null;

  CRUDItemAvailableCols: any[] = [
  ];

    constructor(
      @Inject(forwardRef(() => AppComponent)) public _app: AppComponent,
      private _crudItemService: AuftragsdatenService,
      private dokumenteService: DokumenteService,
      private behaelterService: BehaelterService,
      //private route: ActivatedRoute,
      private sanitizer: DomSanitizer,
      private _injector: Injector
    ) {
      super(_app, _injector);
      this.crudItemService = _crudItemService;

      //this.mode = this.app.mapComponent.mode; // ist sonst zu der Zeit noch nicht initialisiert
      //this.initSelectedFields();
    }

    ngOnInit() { 
      // wenn Map-Mode, dann anderer UserTableColumnState
      if(this.mode == 'map' || this.mode == 'mapOnly') {
        this.CRUDUserTableColumnStateKey = this.CRUDItemBezeichnungSingular + /*'-list'*/ '-map';

        //this.CRUDLazyLoad= true; // "Pseudo"-Lazyload
        //this.CRUDLazyLoadVirtualRowHeight = 40; // bei lazyLoading / virtualScroll muss die TR eine fixe Grösse haben, sonst Scrolling ungenau! - Hier gewünschte Höhe in px angeben
      }
      
      super.ngOnInit(); // HTML Template Plugins
      //this.app.pageTitle = this['pageTitle']; // HTML Template Plugins

      // zaehlerEnabled aus app übernehmen
      if(this._app.zaehlerEnabled != null) this.zaehlerEnabled = this._app.zaehlerEnabled;
      // filterEnabled immer, wenn nicht map-Mode
      if(/*this.zaehlerEnabled == true &&*/ !this.mode.startsWith('map')) this.filterEnabled = true;
    }

    ngAfterViewInit() { // HTML Template Plugins
      if(this._app.inAppMode == true) { // bei inAppMode das Padding vom TableHeader ausblenden
        let tableNativeElement = this.dataTable.el.nativeElement;
        console.log("AuftragsdatenListComponent.ngAfterViewInit() tableNativeElement:", tableNativeElement);
        let firstChild = tableNativeElement.children[0];
        let firstChildFirstChild = firstChild.children[0];
        firstChildFirstChild['style'].padding = '0px';
      }

      super.ngAfterViewInit();

      this.initSelectedFields();
    }


    ngOnDestroy() {
      console.log("AuftragsdatenListComponent.ngOnDestroy()");
      //this.behaelterPipe = null;
    }

    public kill() { // wird aus map aufgerufen
      console.log("AuftragsdatenListComponent.kill()");
      if(this.killForPerformance == true) {
        console.log("AuftragsdatenListComponent.kill() it's already killed! skip!");
        return;
      }
      try {
        let scrollableTableBody = document.getElementsByClassName('p-datatable-wrapper')[0]; // 'ui-table-scrollable-body'
        this.killForPerformance_lastScrollPos = scrollableTableBody.scrollTop;
        console.log("AuftragsdatenListComponent.kill... saving lastScrollPos:", this.killForPerformance_lastScrollPos);
      }
      catch(e) {
        console.log("AuftragsdatenListComponent.kill... warning. couldn't save scrollPos. set to 0");
        this.killForPerformance_lastScrollPos = 0;
      }
      this.killForPerformance = true;
    }
    public unkill(callbackComponentWhenDone: any, callbackFunctionWhenDone: any) { // wird aus map aufgerufen
      console.log("AuftragsdatenListComponent.unkill()");
      if(this.killForPerformance == false) {
        console.log("AuftragsdatenListComponent.unkill() it's already un-killed! skip!");
        return;
      }
      this.killForPerformance = false;
      this.killForPerformance_callbackComponentWhenDone = callbackComponentWhenDone;
      this.killForPerformance_callbackFunctionWhenDone = callbackFunctionWhenDone;
      this.killForPerformance_callbackWhenDone = true;
    }
    private unkill_callbackFunctionWhenDone() {
      if(this.debugMode==true) console.log("AuftragsdatenListComponent.unkill_callbackFunctionWhenDone()");
      this.killForPerformance_callbackWhenDone = false;

      setTimeout(() => {
        try {
          if(this.debugMode==true) console.log("AuftragsdatenListComponent.unkill_callbackFunctionWhenDone... resetting scrollTop killForPerformance_lastScrollPos:", this.killForPerformance_lastScrollPos);
          let scrollableTableBody = document.getElementsByClassName('p-datatable-wrapper')[0]; // 'ui-table-scrollable-body'
          scrollableTableBody.scrollTo(0, this.killForPerformance_lastScrollPos);
        }
        catch(e) {
          console.log("AuftragsdatenListComponent.unkill_callbackFunctionWhenDone... warning. couldn't restore scrollPos. skip!");
        }
        
        this.killForPerformance_callbackFunctionWhenDone(this.killForPerformance_callbackComponentWhenDone);

        this.killForPerformance_callbackComponentWhenDone = null;
        this.killForPerformance_callbackFunctionWhenDone = null;
      }, 20);
    }
    public isKilled() {
      return this.killForPerformance;
    }

    //https://ngdev.space/angular-2-input-property-changes-detection-3ccbf7e366d2
    /*ngOnChanges(changes: SimpleChanges) { // monitoring Input-Changes - nur monitoring/debug - ohne weitere Funktion!!! (kann man weglassen!)
      console.log("AuftragsdatenListComponent.ngOnChanges():", changes);
        
      if(changes.kill != null) {
        if(this.debugMode==true) console.log("AuftragsdatenListComponent.ngOnChanges().it's 'kill'");      
        if(this.debugMode==true) console.log("AuftragsdatenListComponent.ngOnChanges().kill.currentvalue/kill=", changes.kill.currentValue, this.kill);
        if(changes.kill.currentValue == true) {
          this.kill();
        }
        else if(changes.kill.currentValue == false) {
          this.unkill();
        }
      }
      else {
        if(this.debugMode==true) console.log("AuftragsdatenListComponent.ngOnChanges().something else changed.");      
      }
    }
    */

    //LAZY:
    public getCrudItemsForParent() { // siehe map.component. Die soll, wenn das hier lazy ist nicht direkt in crudItems schreiben!
      if(this.debugMode==true) console.log("AuftragsdatenListComponent.getCrudItemsForParent()");
      if(this.CRUDLazyLoad == true) return this.crudItemsAll/*Filtered*/;
      else return this.crudItems;
    }
    
    public setCrudItemsFromParent(crudItems) { // siehe map.component. Die soll, wenn das hier lazy ist nicht direkt in crudItems schreiben!
      if(this.debugMode==true) console.log("AuftragsdatenListComponent.setCrudItemsFromParent() CRUDLazyLoad/crudItems:", this.CRUDLazyLoad, crudItems);
      let dummyPagination = {
        previousPageLink: null,
        nextPageLink: null,
        totalCount: crudItems.length,
        pageSize: crudItems.length,
        currentPage: 1,
        totalPages: 1
      };
  
      this.onCRUDItemsRetrieved(crudItems, dummyPagination);

      setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 100);
      
      if(this.CRUDLazyLoad == true) {
        this.killTable_InUse = false;
        setTimeout(() => {
          this.crudItemsAll = crudItems;
          this.crudItemsAllFiltered = crudItems;
          this.totalRecords = /*crudItems.length*/0;
          //this.crudItems = null;
          this.crudItems = [];
          if(this.debugMode==true) console.log("AuftragsdatenListComponent.setCrudItemsFromParent() filled crudItemsAll:", this.crudItemsAll);
          this.killTable_InUse = false;
          //setTimeout(() => {
          //  this.dataTable['clear'](); // der clear() führt autom. wieder zum load()!
          //}, 100);        
        }, 100);
      }
      else this.crudItems = crudItems;
    }

    public pushCrudItemsFromParent(crudItem) { // siehe map.component. Die soll, wenn das hier lazy ist nicht direkt in crudItems schreiben!
      if(this.debugMode==true) console.log("AuftragsdatenListComponent.pushCrudItemsFromParent() CRUDLazyLoad/crudItem:", this.CRUDLazyLoad, crudItem);
      if(this.CRUDLazyLoad) {
        this.crudItemsAll.push(crudItem);
        this.crudItemsAllFiltered.push(crudItem);
      }
      else this.crudItems.push(crudItem);
      // diese Methode sollte eigentlich gar nicht verwendet werden, weil im lazy mode kein refresh()
      debugger;
    }

    loadLazy(event: LazyLoadEvent) {
      if(this.debugMode==true) console.log("AuftragsdatenListComponent.loadLazy() event:", event);
      if(this.debugMode==true) this.messageWrapperService.postTimedMessage({ severity: 'info', summary: "loading", detail: event.first+" "+event.rows });
      
      setTimeout(() => {
        super.loadLazy(event);
      }, 10);	
    }

    initSelectedFields() {
      this.CRUDItemAvailableCols = [
        /*{
          field: 'createdBy',
          header: this.translate.instant('CreatedBy', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 10,
          showByDefault: false
        },
        {
          field: 'created',
          header: this.translate.instant('Created', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 20,
          showByDefault: false
        },
        {
          field: 'modifiedBy',
          header: this.translate.instant('ModifiedBy', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 30,
          showByDefault: false
        },
        {
          field: 'modified',
          header: this.translate.instant('Modified', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 40,
          showByDefault: false
        },*/
        {
          field: 'auftraggeber',
          header: this.translate.instant('Auftraggeber', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 50,
          showByDefault: false,
          //selectFromValues: this.filterMultiSelects[field+'Options'], // wird beim initialisieren per filterMultiSelectBuildFilter() autom. gefüllt
          //selectFromInit: this.filterMultiSelects[field+'Init'],
        },
        {
          field: 'rechnungsempfaenger',
          header: this.translate.instant('Rechnungsempfänger', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 60,
          showByDefault: false
        },
        {
          field: 'nrVersorgungsunternehmen',
          header: this.translate.instant('Nr. Versorgungsunternehmen', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 70,
          showByDefault: false
        },
        {
          field: 'niederlassungdesVersorgers',
          header: this.translate.instant('Niederlassung des Versorgers', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 80,
          showByDefault: false
        },
        {
          field: 'vorgangsart',
          header: this.translate.instant('Vorgangsart', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 100,
          showByDefault: false
        },
        {
          field: '_pruefergebnis',
          header: this.translate.instant('Prüfergebnis', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 109,
          showByDefault: this.mode == 'list',
          thStyleClass: 'mobile-hidden',
          tdStyleClass: 'mobile-hidden',
        },
        {
          field: 'auftragsdatum',
          header: this.translate.instant('Auftragsdatum', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "betweenMinMax",
          order: 110,
          showByDefault: false,
          customPipe: { 
            pipe: this.datumOhneZeitPipe, 
            args: ['/noUTC']
          }
        },
        {
          field: 'wiedervorlage',
          header: this.translate.instant('Wiedervorlage', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "betweenMinMax",
          order: 115,
          showByDefault: this.mode == 'list',
          thStyleClass: 'mobile-hidden',
          tdStyleClass: 'mobile-hidden',
          //customPipe: this.datumOhneZeitPipe,
          customPipe: { 
            pipe: this.datumOhneZeitPipe, 
            args: ['/noUTC']
          }
        },
        {
          field: 'leistung',
          header: this.translate.instant('Leistung', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 120,
          showByDefault: this.mode == 'list',
          //spezialContentType: 'HTML', // irrelevant weil im HTML separat behandelt
          //customPipe: this.leistungPipe
          //selectFromValues: this.filterMultiSelects['leistung'+'Options'], // wird beim initialisieren per filterMultiSelectBuildFilter() autom. gefüllt
          //selectFromInit: this.filterMultiSelects['leistung'+'Init'],
        },
        {
          field: '_dummy2',
          header: this.translate.instant('Auftrags-Bezeichnung', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 121,
          showByDefault: this.mode == 'list'
        },
        {
          field: 'pruefdatum',
          header: this.translate.instant('Datum durchgeführte Prüfung', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "betweenMinMax",
          order: 122,
          showByDefault: this.mode == 'list',
          thStyleClass: 'mobile-hidden',
          tdStyleClass: 'mobile-hidden',
                    customPipe: { 
            pipe: this.datumOhneZeitPipe, 
            args: ['/noUTC']
          }
        },
        {
          field: 'auftragsbemerkung',
          header: this.translate.instant('Auftragsbemerkung', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 130,
          showByDefault: false
        },
        {
          field: 'bestellposition',
          header: this.translate.instant('Bestellposition', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 150,
          showByDefault: false
        },
        {
          field: 'endedatum',
          header: this.translate.instant('Fälligkeit', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "betweenMinMax",
          order: 160,
          showByDefault: this.mode == 'list',
                    customPipe: { 
            pipe: this.datumOhneZeitPipe, 
            args: ['/noUTC']
          }
        },
        {
          field: 'bestellnummer',
          header: this.translate.instant('Bestell-Nr.', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 161,
          showByDefault: this.mode == 'list',
          thStyleClass: 'mobile-hidden',
          tdStyleClass: 'mobile-hidden',
        },
        {
          field: 'id',
          header: this.translate.instant('Auftrags-Nr.', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 162,
          showByDefault: this.mode == 'list',
        },
        {
          field: 'terminabspracheerforderlich',
          header: this.translate.instant('Terminabsprache erforderlich', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 170,
          showByDefault: false
        },
        {
          field: 'anredekennzeichenKunde',
          header: this.translate.instant('Anredekennzeichen Kunde', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 180,
          showByDefault: false
        },
        {
          field: 'name_1Kunde',
          header: this.translate.instant('Name Kunde', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 190,
          showByDefault: false
        },
        {
          field: 'name_2Kunde',
          header: this.translate.instant('Name 2 Kunde', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 200,
          showByDefault: false
        },
        {
          field: 'strasseKunde',
          header: this.translate.instant('Strasse Kunde', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 210,
          showByDefault: false
        },
        {
          field: 'plzKunde',
          header: this.translate.instant('PLZ Kunde', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 220,
          showByDefault: false
        },
        {
          field: 'ortKunde',
          header: this.translate.instant('Ort Kunde', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 230,
          showByDefault: false
        },
          {
          field: 'ortzusatsKunde',
          header: this.translate.instant('Ortzusatz Kunde', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 240,
          showByDefault: false
        },
        {
          field: 'telefonKunde',
          header: this.translate.instant('Telefon Kunde', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 250,
          showByDefault: false
        },
        {
          field: 'anredekennzeichen',
          header: this.translate.instant('Anredekennzeichen', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 260,
          showByDefault: false
        },
        {
          field: 'kundennummer',
          header: this.translate.instant('Kunden-Nr.', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 261,
          showByDefault: this.mode == 'list',
          thStyleClass: 'mobile-hidden',
          tdStyleClass: 'mobile-hidden',
        },
        {
          field: 'name_1Behaelterstandort',
          header: this.translate.instant('Name '+(this._app.inAppMode != true && this.mode != 'map' ? 'Behälterstandort' : ''), true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 270,
          showByDefault: true,
          tdStyleClass: this.mode == 'map' || this.mode == 'mapOnly' ? 'maplist_col_name' : null,
          thStyleClass: this.mode == 'map' || this.mode == 'mapOnly' ? 'maplist_col_name' : null,
        },
        {
          field: 'name_2Behaelterstandort',
          header: this.translate.instant('Name 2 Behälterstandort', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 280,
          showByDefault: false
        },
        {
          field: 'strasseBehaelterstandort',
          header: this.translate.instant('Strasse Behälterstandort', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 290,
          showByDefault: false
        },
        {
          field: 'behaelternummer',
          header: this.translate.instant('Beh.-Nr.', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 291,
          showByDefault: this.mode == 'list',
          thStyleClass: 'mobile-hidden',
          tdStyleClass: 'mobile-hidden',
        },
        {
          field: 'tankfarbe',
          header: this.translate.instant('Tankfarbe', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 295,
          showByDefault: this.mode == 'list',
          thStyleClass: 'mobile-hidden',
          tdStyleClass: 'mobile-hidden',
        },
        {
          field: 'notizDienstleister',
          header: this.translate.instant('Notiz', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 298,
          showByDefault: this.mode == 'list'
        },
        {
          field: 'plzBehaelterstandort',
          header: this.translate.instant('PLZ '+(this._app.inAppMode != true && this.mode != 'map' ? 'Behälterstandort' : ''), true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 305,
          showByDefault: true,
          tdStyleClass: (this.mode == 'map' || this.mode == 'mapOnly' ? 'maplist_col_plz' : '') + ' mobile-hidden',
          thStyleClass: (this.mode == 'map' || this.mode == 'mapOnly' ? 'maplist_col_plz' : '') + ' mobile-hidden',
        },
        {
          field: 'ortBehaelterstandort',
          header: this.translate.instant('Ort '+(this._app.inAppMode != true && this.mode != 'map' ? 'Behälterstandort' : ''), true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 310,
          showByDefault: true,
          tdStyleClass: this.mode == 'map' || this.mode == 'mapOnly' ? 'maplist_col_ort' : null,
          thStyleClass: this.mode == 'map' || this.mode == 'mapOnly' ? 'maplist_col_ort' : null,
        },
        {
          field: 'ortzusatzBehaelterstandort',
          header: this.translate.instant('Ortzusatz Behälterstandort', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 320,
          showByDefault: false
        },
        {
          field: 'telefonBehaelterstandort',
          header: this.translate.instant('Telefon Behälterstandort', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 330,
          showByDefault: false
        },
        {
          field: 'bemerkungzumBehaelterstandort',
          header: this.translate.instant('Bemerkung', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 340,
          showByDefault: false
        },
        {
          field: 'hersteller',
          header: this.translate.instant('Hersteller', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 360,
          showByDefault: false
        },
        {
          field: 'baujahr',
          header: this.translate.instant('Baujahr', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"betweenMinMax",
          order: 370,
          showByDefault: false,
          //selectFromValues: this.filterMultiSelects[field+'Options'], // wird beim initialisieren per filterMultiSelectBuildFilter() autom. gefüllt
          //selectFromInit: this.filterMultiSelects[field+'Init'],
                    customPipe: { 
            pipe: this.datumOhneZeitPipe, 
            args: ['/noUTC']
          }
        },
        {
          field: 'behaeltervolumen', // Liter
          header: this.translate.instant('Behältervolumen', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 380,
          showByDefault: false
        },
        {
          field: 'fuellvolumen',
          header: this.translate.instant('Füllvolumen', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 390,
          showByDefault: false
        },
        {
          field: 'lagerungsart',
          header: this.translate.instant('Lagerungsart', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 400,
          showByDefault: false
        },
        {
          field: 'schutzart',
          header: this.translate.instant('Schutzart', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 410,
          showByDefault: false
        },
        {
          field: 'ersteAbnahmePruefung',
          header: this.translate.instant('Erste Abnahme Prüfung', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "betweenMinMax",
          order: 420,
          showByDefault: false,
                    customPipe: { 
            pipe: this.datumOhneZeitPipe, 
            args: ['/noUTC']
          }
        },
        {
          field: 'letztePruefungvorInbetriebnahme',
          header: this.translate.instant('Letzte Prüfung vor Inbetriebnahme', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "betweenMinMax",
          order: 430,
          showByDefault: false,
                    customPipe: { 
            pipe: this.datumOhneZeitPipe, 
            args: ['/noUTC']
          }
        },
        {
          field: 'letzteInnerePruefungAnlagenpruefung',
          header: this.translate.instant('Letzte Innere Prüfung Anlagenprüfung', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "betweenMinMax",
          order: 440,
          showByDefault: false,
                    customPipe: { 
            pipe: this.datumOhneZeitPipe, 
            args: ['/noUTC']
          }
        },
        {
          field: 'letzteDruckPruefungFestigkeitspruefung',
          header: this.translate.instant('Letzte Druck-Prüfung Festigkeitsprüfung', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "betweenMinMax",
          order: 450,
          showByDefault: false,
                    customPipe: { 
            pipe: this.datumOhneZeitPipe, 
            args: ['/noUTC']
          }
        },
        {
          field: 'letzteAeusserePruefung',
          header: this.translate.instant('Letzte Äussere Prüfung', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "betweenMinMax",
          order: 460,
          showByDefault: false,
                    customPipe: { 
            pipe: this.datumOhneZeitPipe, 
            args: ['/noUTC']
          }
        },
        {
          field: 'baumusternummerBehaelter',
          header: this.translate.instant('Baumuster-Nr. Behälter', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 470,
          showByDefault: false
        },
        {
          field: 'peilrohrlaenge',
          header: this.translate.instant('Peilrohrlänge', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 480,
          showByDefault: false
        },
        {
          field: 'sicherheitsventilNr',
          header: this.translate.instant('Sicherheitsventil-Nr.', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 490,
          showByDefault: false
        },
        {
          field: 'technischerLieferstopp',
          header: this.translate.instant('Technischer Lieferstopp', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 500,
          showByDefault: false
        },
        {
          field: 'verwaltungsdaten',
          header: this.translate.instant('Verwaltungsdaten', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 510,
          showByDefault: false
        },
        {
          field: 'geodaten_Laenge',
          header: this.translate.instant('Geodaten Länge', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 530,
          showByDefault: false
        },
/*        {
          field: 'geoLocation',
          header: this.translate.instant('Geo Location', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 540,
          showByDefault: false
        },*/
        {
          field: 'ankaNr',
          header: this.translate.instant('Anka-Nr.', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 550,
          showByDefault: false
        },
        {
          field: 'inbetriebnahmeKKSAnlage',
          header: this.translate.instant('Inbetriebnahme KKS Anlage', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "betweenMinMax",
          order: 560,
          showByDefault: false,
                    customPipe: { 
            pipe: this.datumOhneZeitPipe, 
            args: ['/noUTC']
          }
        },
        {
          field: 'letztePruefungKKSAnlage',
          header: this.translate.instant('Letzte Prüfung KKS Anlage', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "betweenMinMax",
          order: 570,
          showByDefault: false,
                    customPipe: { 
            pipe: this.datumOhneZeitPipe, 
            args: ['/noUTC']
          }
        },
        {
          field: 'anKa_Nr_AnlagenschluesselDruck_Anl',
          header: this.translate.instant('AnKa-Nr. Anlagenschlüssel Druck Anl', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 580,
          showByDefault: false
        },
        {
          field: 'anKa_Nr_Anlagenschluessel_Ex_Anl',
          header: this.translate.instant('AnKa-Nr. Anlagenschlüssel Ex Anl', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 590,
          showByDefault: false
        },
        {
          field: 'nutzungsart',
          header: this.translate.instant('Nutzungsart', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 600,
          showByDefault: false
        },
        {
          field: 'anlagenbeschreibung',
          header: this.translate.instant('Anlagenbeschreibung', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 610,
          showByDefault: false
        },
        {
          field: 'avisierungsart',
          header: this.translate.instant('Avisierungsart', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 620,
          showByDefault: false
        },
        {
          field: 'kontaktDaten_Avisierung_Telefon',
          header: this.translate.instant('Kontakt Daten Avisierung Telefon', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 630,
          showByDefault: false
        },
        {
          field: 'kontaktdaten_Avisierung_SMS',
          header: this.translate.instant('Kontaktdaten Avisierung SMS', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 640,
          showByDefault: false
        },
        {
          field: 'kontaktdaten_Avisierung_EMail',
          header: this.translate.instant('Kontaktdaten Avisierung E-Mail', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 650,
          showByDefault: false
        },
        {
          field: 'dienstleisterId',
          header: this.translate.instant('Dienstleister', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 660,
          showByDefault: false,
          //selectFromValues: this.filterMultiSelects[field+'Options'], // wird beim initialisieren per filterMultiSelectBuildFilter() autom. gefüllt
          //selectFromInit: this.filterMultiSelects[field+'Init'],
          customPipe: { 
            pipe: this.dienstleisterPipe, 
            //args: []
          }
        },
        {
          field: 'dispodatum',
          header: this.translate.instant('Dispodatum', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "betweenMinMax",
          order: 670,
          showByDefault: false,
                    customPipe: { 
            pipe: this.datumOhneZeitPipe, 
            args: ['/noUTC']
          }
        },
        {
          field: 'dispozeit',
          header: this.translate.instant('Dispozeit', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 671,
          showByDefault: false
        },
        {
          field: 'benutzerId',
          header: this.translate.instant('Benutzer', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 680,
          showByDefault: false,
          //selectFromValues: this.filterMultiSelects[field+'Options'], // wird beim initialisieren per filterMultiSelectBuildFilter() autom. gefüllt
          //selectFromInit: this.filterMultiSelects[field+'Init'],
          customPipe: this.benutzerPipe
        },
        {
          field: 'ingenieur',
          header: this.translate.instant('Ingenieur', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 690,
          showByDefault: this.mode == 'list'
        },
        /* behaelterId: - async pipe ist hardcoded
                        - filter zeigt noch id
                        -> deaktiviert, man sieht ja eh die BehälterNr. 
        {
          field: 'behaelterId', // das ist der Behälter, der nachträglich bei Auslieferung eingetragen wird!
          header: this.translate.instant('Behälter ausgeliefert', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "in", // siehe CRUDBasicList zu 'in'
          order: 700,
          showByDefault: false,
          //customPipe: this.behaelterPipe,  // async funktioniert über transformByCustomPipe() leider nicht -> hardcoded im HTML
          //customPipeAsync: true
        },
        */
        {
          field: 'dispokennzeichen_1',
          header: this.translate.instant('Dispokennz. 1', true), // siehe XXX: wird noch überschrieben
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 710,
          showByDefault: this.mode == 'list'
        },
        {
          field: 'dispokennzeichen_2',
          header: this.translate.instant('Dispokennz. 2', true), // siehe XXX: wird noch überschrieben
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 710,
          showByDefault: this.mode == 'list'
        },
        {
          field: 'dispokennzeichen_3',
          header: this.translate.instant('Dispokennz. 3', true), // siehe XXX: wird noch überschrieben
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 710,
          showByDefault: this.mode == 'list'
        },
        {
          field: 'dispokennzeichen_4',
          header: this.translate.instant('Dispokennz. 4', true), // siehe XXX: wird noch überschrieben
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 710,
          showByDefault: this.mode == 'list'
        },
        {
          field: 'dispokennzeichen_5',
          header: this.translate.instant('Dispokennz. 5', true), // siehe XXX: wird noch überschrieben
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 710,
          showByDefault: this.mode == 'list'
        },
        {
          field: 'dispokennzeichen_6',
          header: this.translate.instant('Dispokennz. 6', true), // siehe XXX: wird noch überschrieben
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 710,
          showByDefault: this.mode == 'list'
        },

        {
          field: 'vertriebsbuero',
          header: this.translate.instant('Vertriebsbüro', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 810,
          showByDefault: this.mode == 'list'
        },
        {
          field: 'vertriebsbuero_Mitarbeiter',
          header: this.translate.instant('Vertriebsbüro  Mitarbeiter', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 820,
          showByDefault: this.mode == 'list'
        },
        {
          field: 'vertriebsbuero_LeiterRegion',
          header: this.translate.instant('Vertriebsbüro  Leiter Region', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 830,
          showByDefault: this.mode == 'list'
        },
        {
          field: 'vertriebsbuero_Vertrag_durch',
          header: this.translate.instant('Vertriebsbüro  Vertrag durch', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 840,
          showByDefault: this.mode == 'list'
        },
        {
          field: 'vertriebsbuero_TelefonMobil',
          header: this.translate.instant('Vertriebsbüro  Telefon Mobil', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 850,
          showByDefault: this.mode == 'list'
        },
        {
          field: 'vertriebsbuero_Telefax',
          header: this.translate.instant('Vertriebsbüro  Telefax', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 860,
          showByDefault: this.mode == 'list'
        },
        {
          field: 'fixtermin',
          header: this.translate.instant('Fixtermin', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "in",
          showByDefault: this.mode == 'list'
        },
        {
          field: 'fundamentplatten',
          header: this.translate.instant('Fundamentplatten', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 880,
          showByDefault: this.mode == 'list'
        },
        {
          field: 'behaelterkennzeichen_1',
          header: this.translate.instant('Behälterkennz. 1', true), // siehe XXX: wird noch überschrieben
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 890,
          showByDefault: this.mode == 'list',
        },
        {
          field: 'behaelterkennzeichen_2',
          header: this.translate.instant('Behälterkennz. 2', true), // siehe XXX: wird noch überschrieben
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 900,
          showByDefault: this.mode == 'list',
        },
        {
          field: 'behaelterkennzeichen_3',
          header: this.translate.instant('Behälterkennz. 3', true), // siehe XXX: wird noch überschrieben
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 910,
          showByDefault: this.mode == 'list',
        },
        {
          field: 'behaelterkennzeichen_4',
          header: this.translate.instant('Behälterkennz. 4', true), // siehe XXX: wird noch überschrieben
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 920,
          showByDefault: this.mode == 'list',
        },
        {
          field: 'behaelterkennzeichen_5',
          header: this.translate.instant('Behälterkennz. 5', true), // siehe XXX: wird noch überschrieben
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 930,
          showByDefault: this.mode == 'list',
        },
        {
          field: 'behaelterkennzeichen_6',
          header: this.translate.instant('Behälterkennz. 6', true), // siehe XXX: wird noch überschrieben
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 940,
          showByDefault: this.mode == 'list',
        },
        {
          field: 'behaelterkennzeichen_7',
          header: this.translate.instant('Behälterkennz. 7', true), // siehe XXX: wird noch überschrieben
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 950,
          showByDefault: this.mode == 'list',
        },
        {
          field: 'behaelterkennzeichen_8',
          header: this.translate.instant('Behälterkennz. 8', true), // siehe XXX: wird noch überschrieben
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 960,
          showByDefault: this.mode == 'list',
        },
        {
          field: 'tUEVDatum',
          header: this.translate.instant('TÜV-Datum', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "betweenMinMax",
          order: 1010,
          showByDefault: false,
          customPipe: { 
            pipe: this.datumOhneZeitPipe, 
            args: ['/noUTC']
          }
        },
        {
          field: 'letzteBewegung',
          header: this.translate.instant('Letzte Bewegung', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "betweenMinMax",
          order: 1020,
          showByDefault: false,
          customPipe: { 
            pipe: this.datumOhneZeitPipe, 
            args: ['/noUTC']
          }
        },
        {
          field: 'fabrikationszustand',
          header: this.translate.instant('Fabrikationszustand', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 1030,
          showByDefault: true
        },
        {
          field: 'umbauNummer',
          header: this.translate.instant('Umbau Nummer', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 1040,
          showByDefault: this.mode == 'list'
        },
        {
          field: 'umbauBaujahr',
          header: this.translate.instant('Umbau Baujahr', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"betweenMinMax",
          order: 1050,
          showByDefault: false,
          //selectFromValues: this.filterMultiSelects[field+'Options'], // wird beim initialisieren per filterMultiSelectBuildFilter() autom. gefüllt
          //selectFromInit: this.filterMultiSelects[field+'Init'],
                    customPipe: { 
            pipe: this.datumOhneZeitPipe, 
            args: ['/noUTC']
          }
        },
        {
          field: 'umbauHersteller',
          header: this.translate.instant('Umbau Hersteller', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 1060,
          showByDefault: false
        },
        {
          field: 'betriebsdruck',
          header: this.translate.instant('max. Betriebsdruck bar', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: "contains",
          order: 1070,
          showByDefault: false
        },
        {
          field: 'fuellvolumenMax',
          header: this.translate.instant('Füllvolumen Max L', true),
          styleClass: 'columnText',
          sortable: true,
          filterMatchMode: /*"contains"*/"in", // siehe CRUDBasicList zu 'in'
          order: 1080,
          showByDefault: false
        }

      ];

      this.cols = this.CRUDItemAvailableCols.filter(f => f.showByDefault == true);
      this.columnOptions = this.CRUDItemAvailableCols.filter(f => f.showByDefault == false);
    }

    selectCRUDItem(CRUDItem: /*ITitel*/any) { // Overwrite zum CRUDBasic Standard // AM Parent-ChildTab-CRUD
      console.log("AuftragsdatenList.selectCRUDItem() selectedCrudItem:", this.selectedCrudItem);
      console.log("AuftragsdatenList.selectCRUDItem() CRUDItem:", CRUDItem);

      if(CRUDItem.status == 'O') {
        if(CRUDItem.dokumentGuid == null) { // sollte in der Praxis eigentlich nicht vorkommen
          this.messageWrapperService.postTimedMessage({key:'app.main', severity:'error', summary:'Abgeschlossene Aufgabe', detail:'Zu der abgeschlossenen Aufgabe ist kein Prüfergebnis hinterlegt.'});
        }
        else {
          this.messageWrapperService.postTimedMessage({key:'app.main', severity:'info', summary:'Abgeschlossene Aufgabe', detail:'Das Prüfergebnis wird heruntergeladen.'});
          this.dokumenteService.downloadResultByGuidURLViaBlob(CRUDItem.dokumentGuid, 'N');
        }
      }
      else {
        this.app.getMapComponent().selectMarker(CRUDItem.id);

        // wenn AppMode: Klick in Liste -> Sprung zur Map + Detail öffnen
        /*if(this.app.inAppMode == true) {
          let urlParamsObj:any = {};
          if(this.app.mapComponent != null) {
            urlParamsObj = this.app.mapComponent.getCurrentViewParms(); // aktuelle Werte beim Wechsel zw. Map und List mitgeben
            //urlParamsObj.openDetail = CRUDItem.id;
          }
          this.router.navigateByUrl('/dummy', {skipLocationChange: true}).then(() => {
            setTimeout(() => {
              this.router.navigate(['/map'], { 
                //queryParamsHandling: "merge",
                queryParams: urlParamsObj // aktuelle Werte beim Wechsel zw. Map und List mitgeben
              }).then(() => {
                // Auf der Map dann nochmal den Marker blinken lassen
                setTimeout(() => {
                  this.app.mapComponent.selectMarker(CRUDItem.id);
                  // und den Marker-Klick simulieren
                  setTimeout(() => {
                    this.app.mapComponent.markerOnClick(CRUDItem.id);
                  }, 10);	
                }, 500);	
              });
            }, 10);		
          });
        }*/
      }

      // Im Multi-Mark Modus: Wenn ein Abgeschlossenen/FreigabeOffen gewählt - sofort wieder aus der Auswahl nehmen! 
      if(this.multimark_selectionMode == 'multiple' && (CRUDItem.status == 'N' || CRUDItem.status == 'O')) {
        let auftragIdx = this.selectedCrudItem.findIndex(f => f.id == CRUDItem.id);
        if(auftragIdx != null && auftragIdx > -1) this.selectedCrudItem.splice(auftragIdx);
      }
    }

    /*showList_changed() {
      console.log("AuftragsdatenList.showList_changed()");
      if(this.mode == 'map') this.app.mapComponent.setViewType('mapOnly');
      if(this.mode == 'list') this.app.mapComponent.setViewType('listOnly');
      this.alreadyAusgeblendet = true;
    }*/

    onCRUDItemsRetrieved(CRUDItems: /*ITitel*/any[], pagination: /*IPagination*/any) {
      if(CRUDItems != null) {  // solange noch nicht alle Felder wirklich existieren - und wir den "dummy" einsetzen
        CRUDItems.forEach(auftrag => {
          let _pruefergebnis: string = null;
          switch(auftrag.status) {
            case 'O':
              _pruefergebnis = 'Abgeschlossen';
              break;
            case 'N':
              _pruefergebnis = 'Freigabe offen';
              break;
            case 'M':
              _pruefergebnis = 'Begonnen';
              break;
            default:
              _pruefergebnis = 'Offen';
              break;
          }
          auftrag['_pruefergebnis'] = _pruefergebnis;
          auftrag['_dummy2'] = null;
          //auftrag['_dummy3'] = null;
        });
      }

      // multiSelectFilter bestücken
      if(CRUDItems != null) {
        this.CRUDItemAvailableCols.filter(f => f.filterMatchMode == 'in').forEach(element => {
          switch(element.field) {
            case 'leistung':
                this.filterMultiSelectBuildFilter('leistung', this._app.leistungenFiltered != null ? this._app.leistungenFiltered : this._app.leistungen, 'bezeichnung', 'leistung', null, false);
                break;
            case "dienstleisterId":
                this.filterMultiSelectBuildFilter(element.field, CRUDItems, element.field, element.field, this.dienstleisterPipe, false);
                // den label lesbar machen:
                //this.filterMultiSelects[element.field+'Options'].forEach(element => {
                //  element.label = this.dienstleisterPipe.transform(element.label, null);
                //});
                break;
            case "benutzerId":
                this.filterMultiSelectBuildFilter(element.field, CRUDItems, element.field, element.field, this.benutzerPipe, false);
                // den label lesbar machen:
                //this.filterMultiSelects[element.field+'Options'].forEach(element => {
                //  element.label = this.benutzerPipe.transform(element.label, null);
                //});
                break;
            default: 
                this.filterMultiSelectBuildFilter(element.field, CRUDItems, element.field, element.field, null, false);
                break;
          }
        });
      }
            
      super.onCRUDItemsRetrieved(CRUDItems, pagination);
    }

    sizeTable(forceListRedraw?: boolean) { // Overwrite zum CRUDBasic Standard 
      if(this.app.inAppMode == true) {
        // im inAppMode ist alles viel einfacher:
        let landscape = screen.availWidth > screen.availHeight;
        if(landscape) {
          this.scrollHeight = screen.availHeight + "px";
          console.log("AuftragsdatenList.sizeTable() (inAppMode) scrollHeight:", this.scrollHeight);
        }
        else {
          this.scrollHeight = (screen.availHeight / 2) + "px";
          console.log("AuftragsdatenList.sizeTable() (inAppMode) scrollHeight:", this.scrollHeight);
        }
      }
      else {
        let auftragslistDiv = document.getElementById("auftragslistDiv");
        if(auftragslistDiv != null) {
          //let auftragslistDivBounding = auftragslistDiv.getBoundingClientRect();
          let auftragslistDivParent = auftragslistDiv.parentElement;
          if(auftragslistDivParent != null) {
            let auftragslistDivParentBounding = auftragslistDivParent.getBoundingClientRect();
            let dataTableHeaders = document.getElementsByClassName('p-datatable-header');
            if(dataTableHeaders != null && dataTableHeaders.length == 1) {
              let dataTableHeaderBounding = dataTableHeaders[0].getBoundingClientRect();
  
              if(auftragslistDivParentBounding.height != 0 && dataTableHeaderBounding.height != 0) {
                //let scrollbarHeight = 20; // Angenommene Höhe der Scrollbar
                let buffer = 1; // "Vorsichtshalber"
                let availHeightPixels = Math.floor(auftragslistDivParentBounding.height - dataTableHeaderBounding.height - buffer);
                
                let scrollHeight_before = this.scrollHeight;

                //this.scrollHeight = "calc(100vh - " + availHeightPixels.toString() + "px)";
                this.scrollHeight = (availHeightPixels).toString() + "px";

                // Seit virtualScroll gibt es ein Problem:
                // TableRows sind zunächt unsichtbar. Erst wenn man danach die Fenstergrösse ändert wird alles neu gerendert.
                // scrollHeight zu ändern reicht dazu aber nicht - es ist anscheinend ein primeNg-interner Event der das fixt.
                // Abhilfe wäre die scrollHeigt schon ganz zu Beginn zu setzen -> unmöglich, wissen wir ja nicht, ODER:
                // table nach 1. Errechnung der scrollHeight komplett neu rendern (nur bei virtualScroll = mode == 'list'):
                if(this.mode == 'list' && (scrollHeight_before == null || forceListRedraw === true)) {
                  this.killTable_InUse = true;
                  setTimeout(() => {
                    this.killTable_InUse = false;
                  }, 10);	
                }
                
                //console.log("AuftragsdatenList.sizeTable() auftragslistDivParent:", auftragslistDivParent);
                console.log("AuftragsdatenList.sizeTable() auftragslistDivParentBounding.height/dataTableHeaderBounding.height/availHeightPixels:", auftragslistDivParentBounding.height, dataTableHeaderBounding.height, availHeightPixels);
              }
              else { // passiert im Maps-Mode
                this.scrollHeight = null;
                console.log("AuftragsdatenList.sizeTable() setting scrollHeight to null!");
              }
            }
            else {
              console.log("AuftragsdatenList.sizeTable() dataTableHeaders not ready yet.");
            }
          }
          else {
            console.log("AuftragsdatenList.sizeTable() auftragslistDivParent not ready yet.");
          }
        }
      }

      // wenn neu aufgebaut, weil killForPerformance -> dann danach ggf. callbakMethode aufrufen,
      // die map signalisiert, dass fertig
      if(this.killForPerformance_callbackWhenDone == true) {
        this.unkill_callbackFunctionWhenDone();
      }
    }

    multimark_selectionModeChange() {
      console.log("AuftragsdatenList.multimark_selectionModeChange()");
      if(this.multimark_selectionMode == 'single') {
        this.multimark_selectionMode = 'multiple';
        this.selectedCrudItem = [];
        this.messageWrapperService.postTimedMessage({key:'app.main', severity:'info', summary:'Mehrfach-Auswahl', detail:'Mehrfach-Auswahl aktiviert.'});
      }
      else {
        this.multimark_selectionMode = 'single';
        this.selectedCrudItem = null;
        this.messageWrapperService.postTimedMessage({key:'app.main', severity:'info', summary:'Mehrfach-Auswahl', detail:'Mehrfach-Auswahl deaktiviert.'});
      }

      /*let _menusave = this.multimark_selectionButtonItems;
      this.multimark_selectionButtonItems = null;
      setTimeout(() => {
        this.multimark_selectionButtonItems = _menusave;
      }, 10);		*/
      this.multimark_refreshMenu();
    }

    multimark_refreshMenu() {
      let item = this.multimark_selectionButtonItems.find(f => f.id == 'startmulti');
      item.label = this.translate.instant(/*this.CRUDItemKurzform+' bearbeiten'*/this.multimark_selectionMode == 'multiple' ? 'Auswahl beenden' : 'Auswählen', true);

      item = this.multimark_selectionButtonItems.find(f => f.id == 'mark');
      item.disabled = this.multimark_selectionMode != 'multiple';

      item = this.multimark_selectionButtonItems.find(f => f.id == 'demark');
      item.disabled = this.multimark_selectionMode != 'multiple';

      item = this.multimark_selectionButtonItems.find(f => f.id == 'deletemark');
      item.disabled = this.multimark_selectionMode != 'multiple';
    }

    /*multimark_deleteClickEvent(elementId: string) {
      console.log("AuftragsdatenList.deleteClickEvent() elementId:", elementId);
      let element = document.getElementById(elementId);
      console.log("AuftragsdatenList.deleteClickEvent() element:", element);
      let child0 = element.childNodes[0];
      console.log("AuftragsdatenList.deleteClickEvent() child0:", child0);
      let child1 = child0.childNodes[1];
      console.log("AuftragsdatenList.deleteClickEvent() child1:", child1);
      child1.removeEventListener("click", null);
      child1.removeEventListener("onclick", null);
      
      //child0.onclick = null; 
      //child0['removeAttribute']("onclick"); 
    }*/

    multimark_isRowSelected(crudItem: IAuftragsdaten) {
      //console.log("AuftragsdatenList.isRowSelected() crudItem:", crudItem);
      //console.log("AuftragsdatenList.isRowSelected() selectedCrudItem:", this.selectedCrudItem);
      if(this.selectedCrudItem == null) return false;
      let found = this.selectedCrudItem.filter(f => f.id == crudItem.id);
      //console.log("AuftragsdatenList.isRowSelected() found:", found);
      return found != null && found.length == 1;
    }

    //Manuelles Öffnen des Auswahl-Buttons wenn auf diesen geklickt wird
    //Funktioniert momentan nicht im Internet Explorer vermutlich aufgrund 'triggerEvent'
    multimark_openDropdownMenu() {
      let buttonId = "#_DLP_auftrList_splitBtn_auswahl";
      let parentDropDownBtn = document.querySelector(buttonId);
      let dropDownBtn = parentDropDownBtn.children[0].children[1];
      this.triggerEvent(dropDownBtn, "click");
    }

    multimark_markDeMarkFromList(demark: boolean) {
      console.log("AuftragsdatenList.multimark_markDeMarkFromList() selectedCrudItem/demark:", this.selectedCrudItem, demark);
      if(this.app.getMapComponent() != null) {
        // selectedCrudItem ist im Multi-Modus ein Array - Die Programmlogik geht aber an den meisten Stellen davon aus, 
        // das es genau ein Auftrag ist (der aktuell markierte)
        // daher:
        // - copy des arrays erstellen
        // - im loop selectedCrudItem mit jeweils 1 Auftrag bestücken - und verarbeiten
        // - danach selectedCrudItem wieder mit dem array bestücken, bzw. clearen!
        if(this.selectedCrudItem != null && this.selectedCrudItem.length > 0) {
          let copyOfSelectenCrudItemsArray = []; 
          this.selectedCrudItem.forEach(auftrag => {
            copyOfSelectenCrudItemsArray.push(auftrag);
          });
          copyOfSelectenCrudItemsArray.forEach(auftrag => {
            this.selectCRUDItem(auftrag);

            if(demark != true) { // markieren-Modus
              if(this.app.auftraegeRoutenplanung.find(f => f.id == auftrag.id) == null) { // auftrag ist noch nicht markiert
                this.app.getMapComponent().markierenClicked(auftrag.id);
              }
            }
            else { // de-markieren-Modus
              if(this.app.auftraegeRoutenplanung.find(f => f.id == auftrag.id) != null) { // auftrag ist markiert!
                this.app.getMapComponent().demarkierenClicked(auftrag.id);
              }
            }
          });

          //this.selectedCrudItem = []; // Auswahl aufheben

          this.selectedCrudItem = []; 
          copyOfSelectenCrudItemsArray.forEach(auftrag => {
            this.selectedCrudItem.push(auftrag);
          });
        }
      }
    }

    filter($event) {
      debugger;
      console.log("AuftragsdatenList.filter() $event:", $event);
    }

    debug(obj) {
      console.log("AuftragsdatenList.debug() _app.leistungen:", this._app.leistungen);
      super.debug(obj);
    }
}
